import { ethers } from "ethers";
import React, { useEffect, useState } from "react";
import { abi as StakeFeeAbi } from "../../contracts/StakeFee.sol/StakeFee.json";
import { Button, FormControl, Input, InputLabel } from "@material-ui/core";
import { toast } from "react-toastify";
import { getSigner, getNetworkProvider } from "helper/network";
import Select from "components/Select/Select";
import { chainOptions } from "const";
import detectAndSwitchChain from "helper/switchChain";
import { networkConfig } from "const";

// const contractAddress = process.env.REACT_APP_STAKE_FEE_ADDRESS;

const FeeType = {
  Stake: 0,
  Withdraw: 1,
  Claim: 2,
  AddBooster: 3,
  RemoveBooster: 4,
};

export default function StakingFee() {
  const [defaultFee, setDefaultFee] = useState({
    [FeeType.Stake]: 0,
    [FeeType.Withdraw]: 0,
    [FeeType.Claim]: 0,
    [FeeType.AddBooster]: 0,
    [FeeType.RemoveBooster]: 0,
  });
  const [loading, setLoading] = useState(false);
  const [gStakeFeeAddress, setgStakeFeeAddress] = useState("");
  const [chainId, setChainId] = useState(+chainOptions()[0].value);

  const getStakeFeeAddress = async (chainId) => {
    if (!window.ethereum) return;
    // const { ethereum } = window;
    // const provider = new ethers.providers.Web3Provider(ethereum);
    // const { chainId } = await provider.getNetwork();
    return networkConfig[chainId]?.stakeFeeAddress;
  };

  useEffect(() => {
    if (!window.ethereum) return;
    (async () => {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const { chainId } = await provider.getNetwork();
      setChainId(chainId);
    })();
  }, []);

  const handleDefaultFeeSubmit = async (feeType) => {
    await detectAndSwitchChain(chainId);
    setLoading(true);
    const signer = await getSigner(chainId);
    const stakeFeeAddress = await getStakeFeeAddress(chainId);
    const contract = new ethers.Contract(stakeFeeAddress, StakeFeeAbi, signer);
    try {
      await contract.setDefaultFee(
        feeType,
        ethers.utils.parseEther(defaultFee[feeType])
      );
    } catch (err) {
      toast.error(err?.message || "Error");
      console.log(err);
      return;
    } finally {
      setLoading(false);
    }
  };

  async function fetchDefaultFee() {
    try {
      setLoading(true);

      const provider = getNetworkProvider(chainId);
      if (!provider) {
        throw new Error("Invalid provider");
      }

      const stakeFeeAddress = await getStakeFeeAddress(chainId);
      if (!stakeFeeAddress) {
        throw new Error("Invalid stake fee address");
      }

      const contract = new ethers.Contract(
        stakeFeeAddress,
        StakeFeeAbi,
        provider
      );

      const fees = {};

      for await (const key of Object.keys(FeeType)) {
        const feeTypeValue = FeeType[key];

        try {
          const fee = await contract.defaultFee(feeTypeValue);

          fees[feeTypeValue] = ethers.utils.formatEther(fee);
        } catch (err) {
          console.error(`Error fetching fee for ${feeTypeValue}:`, err);
          fees[feeTypeValue] = "Error";
        }

        await new Promise((resolve) => setTimeout(resolve, 1000)); // Throttle requests
      }

      setDefaultFee(fees);
    } catch (error) {
      console.error("Error in fetchDefaultFee:", error);
    } finally {
      setLoading(false);
    }
  }

  async function getstakefeeaddress() {
    const stakeFeeAddress = await getStakeFeeAddress(chainId);
    setgStakeFeeAddress(stakeFeeAddress);
  }

  useEffect(() => {
    if (!chainId) return;
    fetchDefaultFee();
    getstakefeeaddress();
  }, [chainId]);

  return (
    <>
      <ul>
        <li>Price address: {gStakeFeeAddress}</li>
      </ul>

      <div>
        <h3>Default Fee</h3>
        {loading ? <strong>Loading...</strong> : <p>Loaded</p>}

        <Select
          name="chainId"
          label="Select chain"
          onChange={(e) => setChainId(+e)}
          value={chainId ?? "25"}
          options={chainOptions()}
        />
        {Object.keys(FeeType).map((key) => (
          <div style={{ display: "flex", marginBottom: "10px" }} key={key}>
            <FormControl style={{ marginRight: "10px" }}>
              <InputLabel htmlFor={key}>{key}</InputLabel>
              <Input
                id={key}
                label={key}
                type="number"
                value={defaultFee[FeeType[key]]}
                onChange={(e) =>
                  setDefaultFee({
                    ...defaultFee,
                    [FeeType[key]]: e.target.value,
                  })
                }
              />
            </FormControl>
            <Button
              disabled={loading}
              variant="contained"
              color="primary"
              onClick={() => handleDefaultFeeSubmit(FeeType[key])}
            >
              Submit
            </Button>
          </div>
        ))}
      </div>
    </>
  );
}
